export default "__VITE_ASSET__Bd6shn8x__"